import { render, staticRenderFns } from "./SplitPanel.vue?vue&type=template&id=65221162&scoped=true&"
import script from "./SplitPanel.vue?vue&type=script&lang=js&"
export * from "./SplitPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65221162",
  null
  
)

export default component.exports